(function() {
  function initWgeAboutUs() {
    var section = document.querySelector('.wge-about__operators-section');

    if (!section || section.getAttribute('data-wge-about-ready') === 'true') {
      return;
    }

    section.setAttribute('data-wge-about-ready', 'true');

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-wge-operator-card]'));
    var profileConsole = section.querySelector('[data-wge-operator-profile-console]');
    var profileRole = section.querySelector('[data-wge-profile-role]');
    var profileName = section.querySelector('[data-wge-profile-name]');
    var profileLane = section.querySelector('[data-wge-profile-lane]');
    var profileBio = section.querySelector('[data-wge-profile-bio]');
    var desktopCloseTimer = null;

    function isMobileLayout() {
      return window.innerWidth <= 1000;
    }

    function cancelDesktopClose() {
      if (desktopCloseTimer) {
        window.clearTimeout(desktopCloseTimer);
        desktopCloseTimer = null;
      }
    }

    function clearProfileContent() {
      if (profileRole) {
        profileRole.textContent = '';
      }

      if (profileName) {
        profileName.textContent = '';
      }

      if (profileLane) {
        profileLane.textContent = '';
      }

      if (profileBio) {
        profileBio.innerHTML = '';
      }
    }

    function hideDesktopProfile(immediate) {
      if (!profileConsole) {
        return;
      }

      cancelDesktopClose();

      cards.forEach(function(card) {
        card.classList.remove('is-operator-active');
      });

      section.classList.remove('is-profile-active');
      profileConsole.setAttribute('aria-hidden', 'true');

      if (immediate) {
        clearProfileContent();
        return;
      }

      desktopCloseTimer = window.setTimeout(function() {
        if (!section.classList.contains('is-profile-active')) {
          clearProfileContent();
        }

        desktopCloseTimer = null;
      }, 360);
    }

    function showDesktopProfile(card) {
      if (isMobileLayout() || !profileConsole || !card) {
        return;
      }

      var bioSource = card.querySelector('[data-wge-bio-full]');

      if (!bioSource || !profileRole || !profileName || !profileLane || !profileBio) {
        return;
      }

      cancelDesktopClose();

      cards.forEach(function(item) {
        item.classList.toggle('is-operator-active', item === card);
      });

      profileRole.textContent = card.getAttribute('data-wge-operator-role') || '';
      profileName.textContent = card.getAttribute('data-wge-operator-name') || '';
      profileLane.textContent = card.getAttribute('data-wge-operator-lane') || '';
      profileBio.innerHTML = bioSource.innerHTML;

      section.classList.add('is-profile-active');
      profileConsole.setAttribute('aria-hidden', 'false');
    }

    function closeMobileCard(card) {
      if (!card) {
        return;
      }

      var toggle = card.querySelector('[data-wge-mobile-toggle]');
      var bio = card.querySelector('[data-wge-mobile-bio]');
      var symbol = toggle ? toggle.querySelector('.wge-about__operator-mobile-toggle-symbol') : null;

      card.classList.remove('is-bio-open');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }

      if (bio) {
        bio.setAttribute('aria-hidden', 'true');
      }

      if (symbol) {
        symbol.textContent = '+';
      }
    }

    function openMobileCard(card) {
      if (!card) {
        return;
      }

      var toggle = card.querySelector('[data-wge-mobile-toggle]');
      var bio = card.querySelector('[data-wge-mobile-bio]');
      var symbol = toggle ? toggle.querySelector('.wge-about__operator-mobile-toggle-symbol') : null;

      cards.forEach(function(item) {
        if (item !== card) {
          closeMobileCard(item);
        }
      });

      card.classList.add('is-bio-open');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      }

      if (bio) {
        bio.setAttribute('aria-hidden', 'false');
      }

      if (symbol) {
        symbol.textContent = '−';
      }
    }

    function toggleMobileCard(card) {
      if (!card) {
        return;
      }

      if (card.classList.contains('is-bio-open')) {
        closeMobileCard(card);
      } else {
        openMobileCard(card);
      }
    }

    cards.forEach(function(card) {
      var image = card.querySelector('img');

      if (image) {
        image.setAttribute('draggable', 'false');

        image.addEventListener('dragstart', function(event) {
          event.preventDefault();
        });
      }

      card.addEventListener('mouseenter', function() {
        showDesktopProfile(card);
      });

      card.addEventListener('focusin', function() {
        showDesktopProfile(card);
      });

      card.addEventListener('click', function(event) {
        if (!isMobileLayout()) {
          return;
        }

        event.preventDefault();
        toggleMobileCard(card);
      });

      card.addEventListener('keydown', function(event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();

        if (isMobileLayout()) {
          toggleMobileCard(card);
        } else {
          showDesktopProfile(card);
        }
      });
    });

    section.addEventListener('mouseenter', function() {
      if (!isMobileLayout()) {
        cancelDesktopClose();
      }
    });

    section.addEventListener('mouseleave', function() {
      if (!isMobileLayout()) {
        hideDesktopProfile(false);
      }
    });

    section.addEventListener('contextmenu', function(event) {
      if (event.target && event.target.closest('.wge-about__operator-image-wrap')) {
        event.preventDefault();
      }
    });

    window.addEventListener('resize', function() {
      if (isMobileLayout()) {
        hideDesktopProfile(true);
      } else {
        cards.forEach(function(card) {
          closeMobileCard(card);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWgeAboutUs);
  } else {
    initWgeAboutUs();
  }
})();